import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Util } from '../../../utils/util';

@Component({
  selector: 'app-device-registration-modal',
  templateUrl: './device-registration-modal.component.html',
  styleUrls: ['./device-registration-modal.component.styl']
})
export class DeviceRegistrationModalComponent {
  constructor(
    public dialogRef: MatDialogRef<DeviceRegistrationModalComponent>,
  ) {}

  close(): void {
		this.dialogRef.close();
	}

  get isMobile() {
    return Util.isMobile();
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/device-management/device-registration-modal/device-registration-modal.component.ts